<template>
    <div class="member-info">
        <div class="main-wrapper">
            <el-row :gutter="20">
                <el-col :xs="24">
                    <el-col :xs="24">
                        <el-image 
                            v-if="userinfo.avatar" 
                            :src="userinfo.avatar | cdnurl"
                            style="width: 100%;"
                        ></el-image>
                        <el-col :xs="24">
                            <div class="d-flex justify-content-between gap-5">
                                <el-button 
                                    type="warning"
                                    @click="jump('/message?id=' + userinfo.id)"
                                    style="flex: 1;margin: 10px 0;font-weight: 600;" 
                                >
                                    <i class="icon-al-jiaoyou"></i>
                                    {{ $t('GoChat') }}
                                </el-button>
                                <el-button style="flex: 1;margin: 10px 0;font-weight: 600;" type="warning"
                                    @click="jump('/presents/phone?id=' + userinfo.id)">
                                    <i class="el-icon-phone"></i>
                                    Call Me
                                </el-button>
                            </div>
                        </el-col>
                        <el-col :xs="8" :sm="8" :md="8" class="operaButton">
                            <div 
                                v-if="userinfo.liked > 0" 
                                type="primary"
                                class="left-member-button bg-isactive" 
                                @click="like(userId)"
                            >
                                <el-image class="winkImage" :src="zanSrc | cdnurl"></el-image>
                                <br>
                                {{ $t('Liked') }}
                            </div>
                            <div v-else type="primary" class="left-member-button" @click="like(userId)">
                                <el-image class="winkImage" :src="zanSrc | cdnurl"></el-image>
                                <br>
                                {{ $t('Like') }}
                            </div>
                        </el-col>
                        <el-col :xs="8" :sm="8" :md="8" class="operaButton">
                            <div v-if="userinfo.winked > 0" type="primary" class="left-member-button bg-disabled">
                                <el-image class="winkImage" :src="winkSrc | cdnurl"></el-image>
                                <br>
                                {{ $t('Winked') }}
                            </div>
                            <div v-else type="primary" class="left-member-button" @click="wink(userId)">
                                <el-image class="winkImage" :src="winkSrc | cdnurl"></el-image>
                                <br>
                                {{ $t('Wink') }}
                            </div>
                        </el-col>
                        <el-col :xs="8" :sm="8" :md="8" class="operaButton">
                            <div 
                                v-if="userinfo.followed > 0" 
                                type="primary" 
                                class="left-member-button bg-isactive"
                                @click="follow(userId)"
                            >
                                <el-image class="winkImage" :src="likeSrc | cdnurl"></el-image>
                                <br>
                                <template>{{ $t('Followed') }}</template>
                            </div>
                            <div v-else type="primary" class="left-member-button" @click="follow(userId)">
                                <el-image class="winkImage" :src="likeSrc | cdnurl"></el-image>
                                <br>
                                <template>{{ $t('Follow') }}</template>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="24" style="margin-top: 20px;">
                            <h3>PUBLIC PHOTOS</h3>
                            <el-empty v-if="!images" :description="$t('NoMore')"></el-empty>
                            <el-col 
                                v-for="(row, index) in images" 
                                :key="row.id" 
                                :xs="12" 
                                :sm="12" 
                                :md="12"
                                style="position: relative;"
                            >
                                <template v-if="index < 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showImages(index)"></el-image>
                                </template>
                                <template v-if="index == 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showImages(index)"></el-image>
                                    <div v-if="images.length > 4" class="file-other" @click="showImages(index)">
                                        <span>
                                            +{{ images.length - 4 }}
                                        </span>
                                    </div>
                                </template>
                            </el-col>
                        </el-col>
                        <el-col :md="24" :sm="24" :xs="24" style="margin-top: 20px;">
                            <h3>PRIVACY PHOTOS</h3>
                            <el-empty v-if="!privacyImages" :description="$t('NoMore')"></el-empty>
                            <el-col v-for="(row, index) in privacyImages" :key="row.id" :md="12" :sm="12" :xs="12"
                                    style="position: relative;">
                                <template v-if="index < 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showPrivacyImages(index)"></el-image>
                                </template>
                                <template v-if="index == 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showPrivacyImages(index)"></el-image>
                                    <div v-if="privacyImages.length > 4" class="file-other" @click="showImages(index)">
                                        <span>
                                            +{{ privacyImages.length - 4 }}
                                        </span>
                                    </div>
                                </template>
                            </el-col>
                        </el-col>
                        <el-col class="s-m-t-5" :xs="24">
                            <h3>PUBLIC VIDEOS</h3>
                            <el-empty v-if="!videos" :description="$t('NoMore')"></el-empty>
                            <el-col v-for="(row, index) in videos" :key="row.id" :md="12" :sm="12" :xs="12"
                                    style="position: relative;">
                                <template v-if="index < 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showVideos(index)"></el-image>
                                </template>
                                <template v-if="index == 3">
                                    <el-image :src="row.cover | cdnurl" fit="cover" style="width: 150px; height: 150px;"
                                              @click="showVideos(index)"></el-image>
                                    <div v-if="videos.length > 4" class="file-other" @click="showVideos(index)">
                                        <span>
                                            +{{ videos.length - 4 }}
                                        </span>
                                    </div>
                                </template>
                            </el-col>
                        </el-col>
                    </el-col>

                    <el-col :xs="24" v-if="Object.keys(userinfo).length > 0">
                        <div class="card-header">
                            <div class="el-descriptions__title">
                                {{ userinfo.nickname }} ,
                                {{ userinfo.userDetail.age }}
                                <i
                                    :class="{ 'icon-al-zhuangtai': true, 'online-isactive': userinfo.userDetail.online == 1 }"></i>
                            </div>
                            <div class="el-descriptions__extra">ID: {{ userinfo.id }}</div>
                        </div>
                        <el-card>
                            <div class="introduction-div">
                                <template v-if="userinfo.userDetail.introduction.length > 100">
                                    <template v-if="openStatus">
                                        {{ userinfo.userDetail.introduction }}
                                        <el-link type="primary" @click="openStatus = false">
                                            {{ $t('ShowLess') }}
                                        </el-link>
                                    </template>
                                    <template v-else>
                                        {{ userinfo.userDetail.introduction.substr(0, 100) }}...
                                        <el-link type="primary" @click="openStatus = true">
                                            {{ $t('ReadMore') }}
                                        </el-link>
                                    </template>
                                </template>
                                <template v-else>
                                    {{ userinfo.userDetail.introduction }}
                                </template>
                            </div>
                            <el-divider></el-divider>
                            <div class="el-descriptions__header">
                                <div class="el-descriptions__title">
                                    MAIL
                                </div>
                                <div class="el-descriptions__extra">
                                    <el-button 
                                        size="small"  
                                        type="warning"
                                        @click="jump('/message?id=' + userinfo.id)"
                                        style="font-weight: 600;"
                                    >
                                        <i class="icon-al-jiaoyou"></i>
                                        {{ $t('GoChat') }}
                                    </el-button>
                                </div>
                            </div>
                            <send-mail :id="userinfo.id"></send-mail>
                        </el-card>

                        <el-card class="s-m-t-5">
                            <div class="real-presents" @click="routeTo('/presents')">
                                <el-row class="presents-row">
                                    <el-col :xs="24" :sm="12">
                                        <div class="flex-column d-flex ">
                                            <div class="s-m-t-2 t-a-c">
                                                <p class="t-b-1 f-w-b"> {{ $t('SurpriseWithPresent') }} </p>
                                            </div>
                                            <p class="s-m-t-1 s-m-b-3 t-a-c">
                                                {{ $t('SpecialDeliveryDirectlyTo') }}{{ userinfo.nickname }}
                                            </p>
                                            <button
                                                class="ui-button gap-1 ui-button__size-s ui-button__type-primary ui-button__icon-position-left">
                                                <div class="ui-icon ui-icon__display-inline"
                                                    style="width: 20px; height: 20px; visibility: visible;">
                                                    <span class="ui-icon__display-block"
                                                        style="width: 20px; height: 20px;">
                                                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                            <path clip-rule="evenodd"
                                                                d="M14.597 9.06h5l3 4v5h-2c0 1.7-1.3 3-3 3s-3-1.3-3-3h-6c0 1.7-1.3 3-3 3s-3-1.3-3-3h-1v-3h13v-6zm-10.5 9c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zm12 0c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zm.5-7.5v2.5h4.5l-2-2.5h-2.5z"
                                                                fill-rule="evenodd">
                                                            </path>
                                                            <path
                                                                d="M5.842 2c-1.135-.006-2.24 1.087-1.736 2.445H2.202A1.202 1.202 0 0 0 1 5.647v1.201a.6.6 0 0 0 .6.601h5.408V5.647h1.201v1.802h5.407a.6.6 0 0 0 .6-.6V5.646a1.202 1.202 0 0 0-1.2-1.202H11.11c.703-1.964-1.94-3.352-3.16-1.658l-.343.457-.342-.469C6.888 2.24 6.365 2.006 5.842 2zm-.036 1.244c.535 0 .805.648.427 1.027a.603.603 0 0 1-.852-.851.6.6 0 0 1 .425-.176zm3.605 0c.534 0 .805.648.426 1.027a.603.603 0 0 1-.851-.851.6.6 0 0 1 .425-.176zM1.6 8.05v4.806a1.201 1.201 0 0 0 1.201 1.201h9.613a1.201 1.201 0 0 0 1.201-1.201V8.05H8.21v4.806H7.008V8.05H1.6z">
                                                            </path>
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div class="ui-button__label"> {{ $t('ChoosePresent') }}</div>
                                            </button>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="12">
                                        <div class="real-presents_right">
                                            <img src="data:image/png;base64,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"
                                                alt="Present" class="real-presents__img">
                                            <div class="real-presents__img real-presents__imgDelDesc"></div>
                                            <img :src="userinfo.avatar | cdnurl" alt="Avatar"
                                                class="real-presents__img">
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>

                        <el-card class="s-m-t-5">
                            <div v-if="Object.keys(userinfo).length > 0">
                                <el-descriptions :title="$t('BasicInformation')" direction="vertical" :column="4"
                                    size="medium"
                                    border>
                                    <el-descriptions-item :label="$t('nickname')" :span="2">
                                        {{ userinfo.nickname }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('birthday')" :span="2">
                                        {{ userinfo.userDetail.birthday }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('country')" :span="2">
                                        {{ userinfo.userDetail.country_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('Occupation')" :span="2">
                                        {{ userinfo.userDetail.occupation_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('height')" :span="1">
                                        {{ userinfo.userDetail.height }}cm
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('weight')" :span="1">
                                        {{ userinfo.userDetail.weight }}kg
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('eyeColor')" :span="2">
                                        {{ userinfo.userDetail.eye_color_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('hairColor')" :span="1">
                                        {{ userinfo.userDetail.hair_color_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('marriageStatus')" :span="4">
                                        {{ userinfo.userDetail.marriage_info.name }}
                                    </el-descriptions-item>
                                </el-descriptions>
                                <el-descriptions style="margin-top: 20px;" :title="$t('OtherInformation')"
                                    direction="vertical" :column="3" size="medium" border>
                                    <el-descriptions-item :label="$t('Education')">
                                        {{ userinfo.userDetail.edu_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('religion')">
                                        {{ userinfo.userDetail.religion_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('smokingStatus')">
                                        {{ userinfo.userDetail.smoking_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('drinkingStatus')">
                                        {{ userinfo.userDetail.drinking_info.name }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('lookingfor')" :span="2">
                                        {{ userinfo.userDetail.lookingfor }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('introduction')" :span="3">
                                        {{ userinfo.userDetail.introduction }}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="$t('interest')">
                                        <template v-for="(row, index) in userinfo.userDetail.interest_info">
                                            <el-tag size="small" style="margin-left: 10px;">{{ row }}</el-tag>
                                        </template>
                                    </el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </el-card>
                        <el-card class="s-m-t-5">
                            <div class="el-descriptions__header">
                                <div class="el-descriptions__title">{{ userinfo.nickname }}{{ $t("SPosts") }}</div>
                                <div class="el-descriptions__extra"></div>
                            </div>
                            <el-timeline>
                                <el-timeline-item 
                                    v-for="(row, index) in hotList" 
                                    :key="row.id"
                                    :timestamp="row.createtime | getDateDiff" 
                                    color="#3B5998"
                                    placement="top"
                                >
                                    <el-card>
                                        <h4> {{ row.content }}</h4>
                                        <photo-show-view :images="row.imagesArr"></photo-show-view>
                                        <p class="post-footer">
                                            <span class="footer-zan" @click="zan(row)">
                                                <i :class="{ 'icon-al-dianzan': row.liked == 0, 'icon-al-dianzan1': row.liked > 0 }"></i>
                                                {{ $t('Like') }}{{ row.like > 0 ? `(${row.like})` : '' }}
                                            </span>
                                        </p>
                                        <el-dialog 
                                            :title="$t('CommentList')"
                                            :before-close="closeCommentList"
                                            :visible.sync="showCommentItemId == row.id"
                                            custom-class="commentList"
                                            width="600px"
                                        >
                                            <comment v-if="showCommentItemId == row.id" :id="row.id"></comment>
                                        </el-dialog>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                            <el-empty 
                                v-if="hotList.length == 0 && !loading"
                                :description="$t('DataIsEmpty')">
                            </el-empty>
                        </el-card>
                    </el-col>
                </el-col>

                <el-col :xs="24" :sm="6" :md="6">
                    <right-sider-bar></right-sider-bar>
                </el-col>
            </el-row>
        </div>

        <template v-if="imageVisible">
            <CompGallery 
                v-model="imageVisible" 
                :list="images" 
                type="photo" 
                :defaultIndex="imageIndex" 
                :userinfo="userinfo">
            </CompGallery>
        </template>

        <template v-if="privacyImageVisible">
            <CompGallery 
                v-model="privacyImageVisible" 
                :list="privacyImages"
                type="photo" 
                :defaultIndex="privacyImageIndex" 
                :userinfo="userinfo">
            </CompGallery>
        </template>

        <template v-if="videoVisible">
            <CompGallery 
                v-model="videoVisible" 
                :list="videos" 
                type="video" 
                :defaultIndex="videoIndex" 
                :userinfo="userinfo">
            </CompGallery>
        </template>
    </div>
</template>

<script>
import RightSiderBar from '@/page/components/common/RightSiderBar.vue'
import PhotoShowView from '@/page/components/hot/PhotoShowView.vue'
import SendMail from '@/page/components/mailbox/send.vue'
import previewimage from "@/page/components/common/preview-image.vue";
import previewvideo from '@/page/components/common/preview-video.vue'
import CompGallery from "@/components/common/CompGallery.vue";

export default {
    name: 'memberinfo',
    components: {
        RightSiderBar,
        PhotoShowView,
        SendMail,
        previewimage,
        previewvideo,
        CompGallery,
    },
    data: function () {
        return {
            userId: 0,
            userinfo: [],
            winkSrc: "/assets/img/wink.png",
            likeSrc: "/assets/img/like.png",
            zanSrc: "/assets/img/zan.png",
            hotList: [],
            isEnd: false,
            page: 1,
            limit: 12,
            loading: false,
            total: 0,
            showCommentItemId: 0,
            openStatus: false,
            images: [],
            privacyImages: [],
            videos: [],
            imageVisible: false,
            imageIndex: 0,
            privacyImageVisible: false,
            privacyImageIndex: 0,
            videoVisible: false,
            videoIndex: 0,
        }
    },
    created() {
        let that = this;
        that.userId = that.$route.params.id;
        that.getMemberInfo()
        that.getHotList()
    },
    methods: {
        routeTo(path) {
            this.$router.push({
                path,
                query: {
                    to_uid: this.userinfo.id,
                    nickname: this.userinfo.nickname
                }
            })
        },
        showPrivacyImages(index) {
            this.privacyImageIndex = index;
            this.privacyImageVisible = true
        },
        showImages(index) {
            this.imageIndex = index;
            this.imageVisible = true
        },
        showVideos(index) {
            this.videoIndex = index;
            this.videoVisible = true
        },
        getMemberInfo() {
            let that = this;
            that.$http.post('/user/detail', { user_id: that.userId })
                .then((res) => {
                    if (res.code == 1) {
                        that.userinfo = res.data.userinfo
                        that.images = res.data.files.images
                        that.videos = res.data.files.videos
                        that.privacyImages = res.data.files.privacyImages
                    } else {
                        that.$message.error(res.msg);
                    }

                })

        },
        zan(row) {
            let that = this
            that.$http.post('/hot/like', { id: row.id })
                .then((res) => {
                    if (res.code == 1) {
                        if (row.liked == 1) {
                            row.liked = 0
                        } else {
                            row.liked = 1
                        }

                    } else {
                        that.$message.error(res.msg);
                    }
                })
        },
        like(userId) {
            let that = this;
            that.$http.post('/user/like', { to_user_id: userId })
                .then((res) => {
                    if (res.code == 1) {
                        if (that.userinfo.liked > 0) {
                            that.userinfo.liked = 0
                        } else {
                            that.userinfo.liked = 1
                        }
                        that.$message.success(res.msg);

                    } else {
                        that.$message.error(res.msg);
                    }

                })
        },
        wink(userId) {
            let that = this;
            that.$http.post('/user/wink', { to_user_id: userId })
                .then((res) => {
                    if (res.code == 1) {
                        that.userinfo.winked = 1
                        that.$message.success(res.msg);

                    } else {
                        that.$message.error(res.msg);
                    }

                })
        },
        follow(userId) {
            let that = this;
            that.$http.post('/user/follow', { to_user_id: userId })
                .then((res) => {
                    if (res.code == 1) {
                        if (that.userinfo.followed > 0) {
                            that.userinfo.followed = 0
                        } else {
                            that.userinfo.followed = 1
                        }
                        that.$message.success(res.msg);

                    } else {
                        that.$message.error(res.msg);
                    }

                })
        },
        getHotList() {
            let that = this;
            if (that.isEnd == true) {
                return
            }

            let params = {
                page: that.page,
                limit: that.limit,
                user_id: that.userId
            }
            that.$http.get('/hot/list', { params: params })
                .then((res) => {
                    if (res.code == 1) {
                        let list = res.data.list || []
                        if (list.length > 0) {
                            that.hotList = that.hotList.concat(list);
                            that.page += 1
                        } else {
                            that.isEnd = true;
                        }
                    } else {
                        that.$message.error(res.msg);
                    }
                    that.loading = false
                })
        },
        //获取当前可视范围的高度
        getClientHeight() {
            var clientHeight = 0;
            if (document.body.clientHeight && document.documentElement.clientHeight) {
                clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
            } else {
                clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
            }
            return clientHeight
        },

        //获取文档完整的高度
        getScrollHeight() {
            return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        },

        //获取当前滚动条的位置
        getScrollTop() {
            var scrollTop = 0;
            //window.pageYOffset = document.documentElement.scrollTop
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop
            } else if (document.body) {
                scrollTop = document.body.scrollTop
            }
            return scrollTop
        },

        closeCommentList() {
            this.showCommentItemId = ''
        },
        windowScroll() {
            //获取三个值
            var scrollTop = this.getScrollTop()
            var clientHeight = this.getClientHeight()
            var scrollHeight = this.getScrollHeight()
            //如果满足公式则，确实到底了

            if (scrollTop + clientHeight == scrollHeight) {
                //发送异步请求请求数据，同时携带offset并自增offset
                //noMore是自定义变量，如果是最后一批数据则以后都不加载
                if (!this.isEnd) {
                    this.getHotList()
                }
            }

        },
        jump(url) {
            this.$router.push(url)
        },
    },
    mounted() {
        window.addEventListener('scroll', this.windowScroll, true) //监听页面滚动
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll);//销毁滚动事件
    },
    //删除滚动监听器，建议使用beforeRouteLeave，因为destroyed()钩子在路由跳转时不会触发

}
</script>

<style scoped>
.bg-isactive {
    background-color: #3B5998;
    border: 1px solid #3B5998;
    color: #fff;
}

.bg-disabled {
    pointer-events: none;
    opacity: .5;
}

.el-dialog__headerbtn {
    z-index: 5 !important;
}
</style>

<style lang="scss" scoped>
.preview-image-title {
    width: 95vw;
}

.left-member-button {
    text-align: center;
    background-color: #e9ecff;
    border: 1px solid #bdc7ff;
    border-radius: 5px;
    color: #3B5998;
    padding: 5px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background-color: #3B5998;
        border: 1px solid #3B5998;
        color: #fff;
    }
}

.file-other {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    width: 150px;
    height: 150px;
    font-size: 30px;
    font-weight: 600;
    background: #000;
    opacity: 0.6;
    cursor: pointer;

    span {
        margin-left: 40px;
        color: #fff;
    }
}


.card-header {
    display: flex;
    justify-content: space-between;
}

.winkImage {
    width: 30px;
    background-color: unset;
}

.real-presents {
    display: flex;
    justify-content: center;
}

.presents-row {
    display: flex;
    flex-direction: column;
    flex-flow: column-reverse;
    align-items: center;
    margin-right: 0 !important;

    .flex-column {

        .ui-button {
            position: relative;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 24px;
            border-width: 1px;
            border-style: solid;
            border-radius: 4px;
            white-space: nowrap;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            transition: .2s all linear;
        }

        .s-m-b-3 {
            font-size: 14px;
            color: #525252;
        }
    }

    .real-presents_right {
        display: flex;
        align-items: center;

        .real-presents__img {
            width: 68px;
            height: 68px;
            border: 1px solid #ebebeb;
            border-radius: 100px;
            object-fit: cover;
        }

        .real-presents__imgDelDesc {
            width: 104px;
            height: 60px;
            border: none;
            background-repeat: no-repeat;
            background-position: 50%;
            background-size: contain;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANAAAAB4CAMAAAC0NYzFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTMne65LD5uvr6+7u7sPb7pPE5szd6vDw8Ovr65PD5ZTE5v///+vr60GJzP///+vr65PD5l6b1KfJ6Onx+c/h8oSz3mMzdTgAAAAOdFJOUwAQaYRhIs1Anr+HpNrYs33eRgAABL5JREFUeNrtnIGOqyAQRSuKWGnrAur/f+oTqS2oCFRUeOFms+lKsuF0hmEYR2+3pKSkpJNUPP8k5Rm/lv9Z64lC45lNMHfjGZSFBVTNv/Hh2tMJKDATza1xH67dYwbKZuaAwzXkYqI8uKiACkliQcDCWiiF1aSkpJMF79GlK257fwTpyrYi3N23ZbPNw5iALBKXPLKogAyCt6SkpKTvka6oHo2jHlUR6l4Mq+ZHVb6DI6prAADatclnP+OMSP5gwMBD3qr53yWuEXL2AvhodukBjwAqhy96+gjcbLyTZyDymQSCuq4xLvHwLWXlF26wVm2398/t05GetO9PhJ1to3l2A2pcCvcTZNhorGzG07+4BpCW8g+0tSMSfo7ySYVXLv5LttbmOUmdGXkJMcFjTTRGhvzQTBfV5cf9aq2TQ3VeLWfoOQu3FO2FsWwE50eUQ3YoBPjagqPzIRsDsYGgbTphnH50QGofvM86XGX64Jc1CyAO8JoWErMGajLV5Z6H5gFYrKglUSF5Gxcbl897IdGuG5yvHwfMK4mHgfw+KT86J0KciQNBuOpx3TsGaMVOTBhsdyy+impCsIQ0xezWxGMmelyThWLuel8kORgY1JtMdFFaLVbThKQDGmbfzS7RMIGG1TQi4W0gtgTqQwXiQU9kR25ANFwgnvSNXEALRC6wUA12/oPB9crPbKgqbiH1St8dC8QX934g0njU/tns3phKCYgxRr4/gzla5QJrjwcCHqLDdzrUEBQOBEJ4CFGZn1K0DoicBzRuI95ScxcLqVGi8wMkdsUyuwTIYLKfQrWoWPlLzb/TWexDzABEfQCVfnH0QMwM9CK7gLK6RGNtyu/ByR1IHPfG41P3O9C4dMqbf7m73HQgXC4jpw1wKvaeBaQPCnL21/8GBESJ45B77i4uxxSgsSJJXIEgPzbz8nV9UFHIHqiZA7XzZWSOA6OrZby6dlgJZQfQWJSU66pWW6jHpMAJiPaUrgO1XzF1N7IrDh7craLLFBaiukKKGSgDGAugEhx+B7NRl4Sep10eYa2AoAjRgH86o7NDrtOrJyLlZzwN/WIhTM5YOOtARrkBIQCmheM7vfEFZO1yGRJ+hng2fcK60QQFo162QNO9tiva79Q7XT9ICtsA4JInnPB9N/SSdkKfQJ/lX5cYXNWr5h2ovF2rJRDt2q7fIlDHJSBcA3h5688CqDfcXZmP0zBq21qgKdmkGxmDMh46UD9rV9Dd9SLBAzUieSZSVkBaVevjwQKJSVIp92Yrqc/WeBBAj3kXCftmOfPaqGH8EQSQ0khCp7Yltn7Hbnu8CgKoWMk+qe42/vZ4EQRQpj0gMMMBgq20xgTnc9KMmeFIxJogPW7ZXiayGqK7G6QfD+bJiUVDsKlRaX08FAMtWzR/bKO9YgVJT+E9JQeBHogelzhcpWnPC6zN2V7aBspwGtHdtNHiuu9Rgat2IPkpvPm2HtDDHC5R4fO43cp3+p89bpOUlJSUlBSlimpDeXyv9zG9AKyIDcj4npMEFLjL5fEFhfuGqquXkKbqEK+qmL3fqeoQq54RvIapqO7byqFd1SGSsPp+n6RV1SGKjS+6N2L9d0CFm8vFnt5zpcpaUlJS0ln6Bx6wZHcwCeWXAAAAAElFTkSuQmCC);
        }
    }
}
</style>